import { useRequest } from 'ahooks'
import { Form } from 'antd'
import moment from 'moment'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { SpecialProjectLocalStorageModal } from '@/components/special-project-local-storage-modal'
import { routes } from '@/router'
import { SpecialProjectFormLocalStorageKey } from '@/schemas'

import { DevlopForm } from './devlop-form.component'
import { Devlop } from './devlop.schema'

export const DevlopCreate: React.FC<{ devlop?: Devlop }> = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  const { run: onSubmit } = useRequest(
    (data) => ({
      url: '/api/devlop',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: (data: Devlop) => {
        history.push(routes.devlop.detail(data.selfId))
      },
    }
  )

  return (
    <>
      <DevlopForm form={form} onSubmit={onSubmit} />
      <SpecialProjectLocalStorageModal
        localStorageKey={SpecialProjectFormLocalStorageKey.DEVLOP}
        onSetForm={(value) => {
          form.setFieldsValue({
            ...value,
            range: value.range ? [moment(value.range[0]), moment(value.range[1])] : undefined,
            localCacheExpireTime: undefined,
          })
        }}
      />
    </>
  )
}
